import book1 from '../assets/items/book1.png'
import book2 from '../assets/items/book2.png'
import book3 from '../assets/items/book3.png'
export const books = [
        {
            id:'book1',
            name: '2 ★',
            exp: 1000,
            img : book1
        },
        {
            id:'book2',
            name: '3 ★',
            exp: 5000,
            img : book2
        },
        {
            id:'book3',
            name: '4 ★',
            exp: 20000,
            img : book3
        }
    ]
